import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation  } from 'react-router-dom';
import { useAdminAuth } from '../../../context/AdminAuthContext';
import '../../css/BdStyles.css';
import { API_BASE_URL } from '../scripts/control';
import UserCreationModal from './UserCreationModal';

const Header = () => {
    const { isLoggedIn, isAdmin, logout } = useAdminAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [showUserModal, setShowUserModal] = useState(false);

    const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    };

    const handleSearchSubmit = (event) => {
        event.preventDefault();
        const currentPage = location.pathname;
        if (searchQuery) {
            navigate(`${currentPage}?search=${searchQuery}`);
        }
    };

    const handleLogin = () => {
        navigate('/ligaincom/bd/login');
    };
    
    const handleLogout = () => {
        alert("Has salido de la edición");
        logout();
    };

    useEffect(() => {
    if (searchQuery) {
        fetch(`${API_BASE_URL}/search.php?search=${searchQuery}`)
            .then(response => response.json())
            .then(data => {
                setSearchResults(data); // Guardamos los resultados
            })
            .catch(error => console.error("Error en la búsqueda:", error));
    }
}, [searchQuery]);

    return (
        <div className="bd">
        <header>
            <nav className="navbar navbar-expand-lg navbar-light bdnavbar">
                <Link className="navbar-brand" to={`/ligaincom/bd`}>
                    <img src={`${API_BASE_URL}/public/uploads/images/logo.png`} width="180px" height="auto" alt="Logo" />
                </Link>
                <button className="navbar-toggler toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                
                {/* Todo lo que debe colapsar debe ir dentro de este div */}
                <div className="collapse navbar-collapse collapsed" id="navbarNav">
                    <ul className="navbar-nav me-auto">
                        <li className="nav-item">
                            <Link className="nav-link ms-2" to="/ligaincom/bd/peliculas">Películas</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link ms-2" to="/ligaincom/bd/series">Series</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link ms-2" to="/ligaincom/bd/etiquetas">Etiquetas</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link ms-2" to="/ligaincom/bd/favoritos">Favoritos</Link>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link ms-2" href="mailto:ligaincom@us.es">Contacta</a>
                        </li>
                        <li className="nav-item">
                            <div className="d-block ms-auto align-items-center">
                                {(!isLoggedIn) && (
                                    <button
                                        className="btn logout-btn"
                                        style={{
                                            backgroundColor: 'white',
                                            border: '2px solid #005EC4',
                                            borderRadius: '15px',
                                            color: '#005EC4',
                                            cursor: 'pointer',
                                            padding: '10px',
                                            textDecoration: 'none'
                                        }}
                                        onClick={handleLogin}
                                    >
                                        Login
                                    </button>
                                )}
                            </div>
                            <div className="d-block ms-auto align-items-center">
                                {(isLoggedIn)  && (
                                    <button
                                        className="btn logout-btn"
                                        style={{
                                            backgroundColor: 'white',
                                            border: '2px solid #005EC4',
                                            borderRadius: '15px',
                                            color: '#005EC4',
                                            cursor: 'pointer',
                                            padding: '10px',
                                            textDecoration: 'none'
                                        }}
                                        onClick={handleLogout}
                                    >
                                        Logout
                                    </button>
                                )}
                            </div>
                            {(!isLoggedIn) && (    
                                <div className="d-block ms-auto align-items-right">
                                    <button 
                                        className="btn logout-btn ms-3"
                                        style={{
                                                backgroundColor: 'white',
                                                border: '2px solid #005EC4',
                                                borderRadius: '15px',
                                                color: '#005EC4',
                                                cursor: 'pointer',
                                                padding: '10px',
                                                textDecoration: 'none'
                                            }}
                                            onClick={() => setShowUserModal(true)}>Crear Usuario</button>
                                </div>
                            )}
                        </li>
                        {/*<li className="nav-item">
                        {<form className="search">
                                <input className="form-control me-2" type="search" aria-label="Buscar" />
                                <button className="btn btn-outline-success searchbutton" type="submit">Buscar</button>
                        </form>}
                        </li>*/}
                    </ul>
                </div>
            </nav>
            {showUserModal && (
              <UserCreationModal onClose={() => setShowUserModal(false)} />
            )}
        </header>
        </div>
    );
};

export default Header;
